import { POST_ENC } from "./common/EncryptedHttp";
import { BASE_URL } from "./common/const";

export const SendEmail = (data: any) =>
  POST_ENC(`${BASE_URL}/api/SendEmail/FileSendToEmail`, data);

export const SendMultipleFilesToEmail = (data: any) =>
  POST_ENC(`${BASE_URL}/api/SendEmail/MultipleFilesSendToEmail`, data);